import React from 'react'
import { Space } from 'generated/types'
import { CheckinsByDayChart, CheckinsByDayChartProps } from 'components/charts/CheckinsByDayChart'
import { DateTime } from 'luxon'

const SpaceDailyCheckinChart: React.FC<{ sessions: Space['checkinSessions'] }> = ({ sessions }) => {
  const sortedSessions = [...sessions].sort((a, b) => (
    DateTime.fromISO(a.startTime) > DateTime.fromISO(b.startTime) ? 1 : -1
  ))

  const data: CheckinsByDayChartProps['data'] = sortedSessions.map((session) => ({
    date: session.startTime,
    count: session.userCount,
  }))
  return <CheckinsByDayChart data={data} height={50} />
}

export default SpaceDailyCheckinChart
